import type { EmailMetricsResponse } from "@/types/api";

/**
 * Honest email-service status tile — renders "Oczekuje deployu" explicitly
 * while GET /v1/vigil/email returns status="pending_deploy". Zero mock data,
 * zero hidden state. Ported from
 * products/x2mail-admin/src/components/EmailPendingTile.tsx.
 *
 * Once email_service ships, the backend starts returning a different
 * `status` and this renders the real payload instead.
 */
export interface EmailPendingTileProps {
  status: EmailMetricsResponse | null;
  loading?: boolean;
}

export function EmailPendingTile({ status, loading = false }: EmailPendingTileProps) {
  if (loading || !status) {
    return (
      <div className="rounded-lg border border-zinc-800 bg-zinc-900 p-4">
        <p className="text-xs text-zinc-500">Ładowanie metryk email…</p>
      </div>
    );
  }

  if (status.status === "pending_deploy") {
    return (
      <div
        role="region"
        aria-label="Metryki email"
        className="rounded-lg border border-zinc-700 bg-zinc-900 p-4"
      >
        <p className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Metryki email</p>
        <p className="mt-1 text-sm text-zinc-400">
          Oczekuje deployu <span className="font-mono text-zinc-300">email_service</span>
        </p>
        {status.reason && <p className="mt-0.5 text-xs text-zinc-600">{status.reason}</p>}
      </div>
    );
  }

  // Future: real data once email_service ships.
  return (
    <div
      role="region"
      aria-label="Metryki email"
      className="rounded-lg border border-zinc-800 bg-zinc-900 p-4"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-zinc-500">Metryki email</p>
      <pre className="mt-1 overflow-auto text-xs text-zinc-400">
        {JSON.stringify(status.data, null, 2)}
      </pre>
    </div>
  );
}
